(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Colelection-product-grid-lorcana"] && !window.DesignMode) return;
  try {
    
class CollectionManager {
  constructor() {
    this.filterManager = new FilterManager();
    this.cartManager = new CartManager();
    this.initializeButtons();
  }

  initializeButtons() {
    document.querySelectorAll('.product-button').forEach(button => {
      new ProductButton(button);
    });
  }
}

class FilterManager {
  constructor() {
    this.form = document.querySelector('.filter-form');
    this.filterGroups = document.querySelectorAll('.filter-group');
    this.filterInputs = document.querySelectorAll('.filter-option input');
    this.sortSelect = document.querySelector('.sort-select');
    this.perPageSelect = document.querySelector('.per-page-select');
    
    this.init();
  }

  init() {
    this.setupFilterGroups();
    this.setupFilterInputs();
    this.setupSort();
    this.setupPerPage();
    this.initMobileSidebar();
  }

  initMobileSidebar() {
    // Crear botón de toggle para móvil
    const toggleButton = document.createElement('button');
    toggleButton.className = 'filter-toggle-button';
    toggleButton.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M3 5h12M3 9h12M3 13h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      Filtros
    `;
    document.body.appendChild(toggleButton);

    // Crear overlay
    const overlay = document.createElement('div');
    overlay.className = 'sidebar-overlay';
    document.body.appendChild(overlay);

    // Crear header del sidebar
    const sidebarHeader = document.createElement('div');
    sidebarHeader.className = 'sidebar-header';
    sidebarHeader.innerHTML = `
      <h3 class="sidebar-title">Filtros</h3>
      <button class="sidebar-close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    `;
    
    // Insertar header al inicio del sidebar
    const sidebar = document.querySelector('.collection-sidebar');
    sidebar.insertBefore(sidebarHeader, sidebar.firstChild);

    // Event listeners
    toggleButton.addEventListener('click', () => this.toggleSidebar(true));
    overlay.addEventListener('click', () => this.toggleSidebar(false));
    sidebarHeader.querySelector('.sidebar-close').addEventListener('click', () => this.toggleSidebar(false));

    // Cerrar al cambiar filtros en mobile
    if (window.innerWidth <= 991) {
      this.filterInputs.forEach(input => {
        input.addEventListener('change', () => {
          // Pequeño delay para que el usuario vea que se seleccionó el filtro
          setTimeout(() => this.toggleSidebar(false), 300);
        });
      });
    }
  }

  toggleSidebar(show) {
    const sidebar = document.querySelector('.collection-sidebar');
    const overlay = document.querySelector('.sidebar-overlay');
    
    if (show) {
      sidebar.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('sidebar-open');
    } else {
      sidebar.classList.remove('active');
      overlay.classList.remove('active');
      document.body.classList.remove('sidebar-open');
    }
  }

  setupFilterGroups() {
    this.filterGroups.forEach(group => {
      const header = group.querySelector('.filter-group-header');
      const content = group.querySelector('.filter-group-content');
      const toggle = header.querySelector('.filter-toggle');

      // Establecer estado inicial
      content.classList.add('active');
      toggle.textContent = '▼';

      header.addEventListener('click', () => {
        const isExpanded = content.classList.contains('active');
        
        if (isExpanded) {
          content.classList.remove('active');
          toggle.textContent = '▼';
        } else {
          content.classList.add('active');
          toggle.textContent = '▲';
        }
      });
    });
  }

  setupFilterInputs() {
    this.filterInputs.forEach(input => {
      input.addEventListener('change', () => this.handleFilterChange());
    });
  }

  setupSort() {
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location = url.toString();
      });
    }
  }

  setupPerPage() {
    if (this.perPageSelect) {
      this.perPageSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('view', e.target.value);
        window.location = url.toString();
      });
    }
  }

  handleFilterChange() {
    const formData = new FormData(this.form);
    const url = new URL(window.location.href);
    
    // Limpiar filtros existentes
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.')) {
        url.searchParams.delete(key);
      }
    });

    // Añadir filtros activos
    for (let [key, value] of formData.entries()) {
      url.searchParams.append(key, value);
    }

    // Mantener sort y page_size
    const currentSort = url.searchParams.get('sort_by');
    const currentView = url.searchParams.get('view');

    if (currentSort) url.searchParams.set('sort_by', currentSort);
    if (currentView) url.searchParams.set('view', currentView);

    window.location = url.toString();
  }
}

class ProductButton {
  constructor(button) {
    this.button = button;
    this.productId = button.dataset.productId;
    this.productHandle = button.dataset.productHandle;
    this.action = button.dataset.action;
    this.originalText = button.textContent;
    
    this.init();
  }

  init() {
    this.button.addEventListener('click', () => this.handleClick());
  }

  async handleClick() {
    if (this.button.disabled) return;

    try {
      this.setLoading(true);
      
      if (this.action === 'preorder') {
        await this.handlePreorder();
      } else {
        await this.handleAddToCart();
      }
      
      this.showSuccess();
      CartManager.updateCart();
      
    } catch (error) {
      console.error('Error:', error); display: none
      this.showError(); display: none
    }
  }

  async handleAddToCart() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding to cart');
  }

  async handlePreorder() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1,
          properties: {
            '_preorder': true,
            'Estimated Shipping': 'Pre-order - 2-3 semanas',
            'Pre-order': 'Artículo de pre-venta'
          }
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding pre-order');
  }

  setLoading(isLoading) {
    this.button.enabled = isLoading; 
    this.button.classList.toggle('loading', isLoading);display: none
    this.button.textContent = isLoading ? 'Procesando...' : this.originalText; display: none
  }

  showSuccess() {
    const message = this.action === 'preorder' ? 'Pre-orden agregada' : 'Agregado al carrito';
    this.button.textContent = message;
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }

  showError() {
    this.button.textContent = 'Error'; display: none
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }
}

class CartManager {
  static async updateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));
    } catch (error) {
      console.error('Error updating cart:', error); display: none
    }
  }
}

// Agregar al JavaScript existente
document.addEventListener('DOMContentLoaded', function() {
  const priceForm = document.querySelector('.filter-form');
  const priceInputs = document.querySelectorAll('.price-range-inputs input');
  
  priceInputs.forEach(input => {
    input.addEventListener('input', function() {
      if (this.value < 0) this.value = 0;
    });
  });

  document.querySelector('.apply-price-filter')?.addEventListener('click', function(e) {
    e.preventDefault();
    priceForm.submit();
  });
});  

// Inicializar
document.addEventListener('DOMContentLoaded', () => {
  new CollectionManager();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Colelection-product-grid-onepiece"] && !window.DesignMode) return;
  try {
    
class CollectionManager {
  constructor() {
    this.filterManager = new FilterManager();
    this.cartManager = new CartManager();
    this.initializeButtons();
  }

  initializeButtons() {
    document.querySelectorAll('.product-button').forEach(button => {
      new ProductButton(button);
    });
  }
}

class FilterManager {
  constructor() {
    this.form = document.querySelector('.filter-form');
    this.filterGroups = document.querySelectorAll('.filter-group');
    this.filterInputs = document.querySelectorAll('.filter-option input');
    this.sortSelect = document.querySelector('.sort-select');
    this.perPageSelect = document.querySelector('.per-page-select');
    
    this.init();
  }

  init() {
    this.setupFilterGroups();
    this.setupFilterInputs();
    this.setupSort();
    this.setupPerPage();
    this.initMobileSidebar();
  }

  initMobileSidebar() {
    // Crear botón de toggle para móvil
    const toggleButton = document.createElement('button');
    toggleButton.className = 'filter-toggle-button';
    toggleButton.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M3 5h12M3 9h12M3 13h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      Filtros
    `;
    document.body.appendChild(toggleButton);

    // Crear overlay
    const overlay = document.createElement('div');
    overlay.className = 'sidebar-overlay';
    document.body.appendChild(overlay);

    // Crear header del sidebar
    const sidebarHeader = document.createElement('div');
    sidebarHeader.className = 'sidebar-header';
    sidebarHeader.innerHTML = `
      <h3 class="sidebar-title">Filtros</h3>
      <button class="sidebar-close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    `;
    
    // Insertar header al inicio del sidebar
    const sidebar = document.querySelector('.collection-sidebar');
    sidebar.insertBefore(sidebarHeader, sidebar.firstChild);

    // Event listeners
    toggleButton.addEventListener('click', () => this.toggleSidebar(true));
    overlay.addEventListener('click', () => this.toggleSidebar(false));
    sidebarHeader.querySelector('.sidebar-close').addEventListener('click', () => this.toggleSidebar(false));

    // Cerrar al cambiar filtros en mobile
    if (window.innerWidth <= 991) {
      this.filterInputs.forEach(input => {
        input.addEventListener('change', () => {
          // Pequeño delay para que el usuario vea que se seleccionó el filtro
          setTimeout(() => this.toggleSidebar(false), 300);
        });
      });
    }
  }

  toggleSidebar(show) {
    const sidebar = document.querySelector('.collection-sidebar');
    const overlay = document.querySelector('.sidebar-overlay');
    
    if (show) {
      sidebar.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('sidebar-open');
    } else {
      sidebar.classList.remove('active');
      overlay.classList.remove('active');
      document.body.classList.remove('sidebar-open');
    }
  }

  setupFilterGroups() {
    this.filterGroups.forEach(group => {
      const header = group.querySelector('.filter-group-header');
      const content = group.querySelector('.filter-group-content');
      const toggle = header.querySelector('.filter-toggle');

      // Establecer estado inicial
      content.classList.add('active');
      toggle.textContent = '▼';

      header.addEventListener('click', () => {
        const isExpanded = content.classList.contains('active');
        
        if (isExpanded) {
          content.classList.remove('active');
          toggle.textContent = '▼';
        } else {
          content.classList.add('active');
          toggle.textContent = '▲';
        }
      });
    });
  }

  setupFilterInputs() {
    this.filterInputs.forEach(input => {
      input.addEventListener('change', () => this.handleFilterChange());
    });
  }

  setupSort() {
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location = url.toString();
      });
    }
  }

  setupPerPage() {
    if (this.perPageSelect) {
      this.perPageSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('view', e.target.value);
        window.location = url.toString();
      });
    }
  }

  handleFilterChange() {
    const formData = new FormData(this.form);
    const url = new URL(window.location.href);
    
    // Limpiar filtros existentes
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.')) {
        url.searchParams.delete(key);
      }
    });

    // Añadir filtros activos
    for (let [key, value] of formData.entries()) {
      url.searchParams.append(key, value);
    }

    // Mantener sort y page_size
    const currentSort = url.searchParams.get('sort_by');
    const currentView = url.searchParams.get('view');

    if (currentSort) url.searchParams.set('sort_by', currentSort);
    if (currentView) url.searchParams.set('view', currentView);

    window.location = url.toString();
  }
}

class ProductButton {
  constructor(button) {
    this.button = button;
    this.productId = button.dataset.productId;
    this.productHandle = button.dataset.productHandle;
    this.action = button.dataset.action;
    this.originalText = button.textContent;
    
    this.init();
  }

  init() {
    this.button.addEventListener('click', () => this.handleClick());
  }

  async handleClick() {
    if (this.button.disabled) return;

    try {
      this.setLoading(true);
      
      if (this.action === 'preorder') {
        await this.handlePreorder();
      } else {
        await this.handleAddToCart();
      }
      
      this.showSuccess();
      CartManager.updateCart();
      
    } catch (error) {
      console.error('Error:', error); display: none
      this.showError(); display: none
    }
  }

  async handleAddToCart() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding to cart');
  }

  async handlePreorder() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1,
          properties: {
            '_preorder': true,
            'Estimated Shipping': 'Pre-order - 2-3 semanas',
            'Pre-order': 'Artículo de pre-venta'
          }
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding pre-order');
  }

  setLoading(isLoading) {
    this.button.enabled = isLoading; 
    this.button.classList.toggle('loading', isLoading);display: none
    this.button.textContent = isLoading ? 'Procesando...' : this.originalText; display: none
  }

  showSuccess() {
    const message = this.action === 'preorder' ? 'Pre-orden agregada' : 'Agregado al carrito';
    this.button.textContent = message;
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }

  showError() {
    this.button.textContent = 'Error'; display: none
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }
}

class CartManager {
  static async updateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));
    } catch (error) {
      console.error('Error updating cart:', error); display: none
    }
  }
}

// Agregar al JavaScript existente
document.addEventListener('DOMContentLoaded', function() {
  const priceForm = document.querySelector('.filter-form');
  const priceInputs = document.querySelectorAll('.price-range-inputs input');
  
  priceInputs.forEach(input => {
    input.addEventListener('input', function() {
      if (this.value < 0) this.value = 0;
    });
  });

  document.querySelector('.apply-price-filter')?.addEventListener('click', function(e) {
    e.preventDefault();
    priceForm.submit();
  });
});  

// Inicializar
document.addEventListener('DOMContentLoaded', () => {
  new CollectionManager();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Colelection-product-grid-yugi"] && !window.DesignMode) return;
  try {
    
class CollectionManager {
  constructor() {
    this.filterManager = new FilterManager();
    this.cartManager = new CartManager();
    this.initializeButtons();
  }

  initializeButtons() {
    document.querySelectorAll('.product-button').forEach(button => {
      new ProductButton(button);
    });
  }
}

class FilterManager {
  constructor() {
    this.form = document.querySelector('.filter-form');
    this.filterGroups = document.querySelectorAll('.filter-group');
    this.filterInputs = document.querySelectorAll('.filter-option input');
    this.sortSelect = document.querySelector('.sort-select');
    this.perPageSelect = document.querySelector('.per-page-select');
    
    this.init();
  }

  init() {
    this.setupFilterGroups();
    this.setupFilterInputs();
    this.setupSort();
    this.setupPerPage();
    this.initMobileSidebar();
  }

  initMobileSidebar() {
    // Crear botón de toggle para móvil
    const toggleButton = document.createElement('button');
    toggleButton.className = 'filter-toggle-button';
    toggleButton.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M3 5h12M3 9h12M3 13h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      Filtros
    `;
    document.body.appendChild(toggleButton);

    // Crear overlay
    const overlay = document.createElement('div');
    overlay.className = 'sidebar-overlay';
    document.body.appendChild(overlay);

    // Crear header del sidebar
    const sidebarHeader = document.createElement('div');
    sidebarHeader.className = 'sidebar-header';
    sidebarHeader.innerHTML = `
      <h3 class="sidebar-title">Filtros</h3>
      <button class="sidebar-close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    `;
    
    // Insertar header al inicio del sidebar
    const sidebar = document.querySelector('.collection-sidebar');
    sidebar.insertBefore(sidebarHeader, sidebar.firstChild);

    // Event listeners
    toggleButton.addEventListener('click', () => this.toggleSidebar(true));
    overlay.addEventListener('click', () => this.toggleSidebar(false));
    sidebarHeader.querySelector('.sidebar-close').addEventListener('click', () => this.toggleSidebar(false));

    // Cerrar al cambiar filtros en mobile
    if (window.innerWidth <= 991) {
      this.filterInputs.forEach(input => {
        input.addEventListener('change', () => {
          // Pequeño delay para que el usuario vea que se seleccionó el filtro
          setTimeout(() => this.toggleSidebar(false), 300);
        });
      });
    }
  }

  toggleSidebar(show) {
    const sidebar = document.querySelector('.collection-sidebar');
    const overlay = document.querySelector('.sidebar-overlay');
    
    if (show) {
      sidebar.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('sidebar-open');
    } else {
      sidebar.classList.remove('active');
      overlay.classList.remove('active');
      document.body.classList.remove('sidebar-open');
    }
  }

  setupFilterGroups() {
    this.filterGroups.forEach(group => {
      const header = group.querySelector('.filter-group-header');
      const content = group.querySelector('.filter-group-content');
      const toggle = header.querySelector('.filter-toggle');

      // Establecer estado inicial
      content.classList.add('active');
      toggle.textContent = '▼';

      header.addEventListener('click', () => {
        const isExpanded = content.classList.contains('active');
        
        if (isExpanded) {
          content.classList.remove('active');
          toggle.textContent = '▼';
        } else {
          content.classList.add('active');
          toggle.textContent = '▲';
        }
      });
    });
  }

  setupFilterInputs() {
    this.filterInputs.forEach(input => {
      input.addEventListener('change', () => this.handleFilterChange());
    });
  }

  setupSort() {
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location = url.toString();
      });
    }
  }

  setupPerPage() {
    if (this.perPageSelect) {
      this.perPageSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('view', e.target.value);
        window.location = url.toString();
      });
    }
  }

  handleFilterChange() {
    const formData = new FormData(this.form);
    const url = new URL(window.location.href);
    
    // Limpiar filtros existentes
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.')) {
        url.searchParams.delete(key);
      }
    });

    // Añadir filtros activos
    for (let [key, value] of formData.entries()) {
      url.searchParams.append(key, value);
    }

    // Mantener sort y page_size
    const currentSort = url.searchParams.get('sort_by');
    const currentView = url.searchParams.get('view');

    if (currentSort) url.searchParams.set('sort_by', currentSort);
    if (currentView) url.searchParams.set('view', currentView);

    window.location = url.toString();
  }
}

class ProductButton {
  constructor(button) {
    this.button = button;
    this.productId = button.dataset.productId;
    this.productHandle = button.dataset.productHandle;
    this.action = button.dataset.action;
    this.originalText = button.textContent;
    
    this.init();
  }

  init() {
    this.button.addEventListener('click', () => this.handleClick());
  }

  async handleClick() {
    if (this.button.disabled) return;

    try {
      this.setLoading(true);
      
      if (this.action === 'preorder') {
        await this.handlePreorder();
      } else {
        await this.handleAddToCart();
      }
      
      this.showSuccess();
      CartManager.updateCart();
      
    } catch (error) {
      console.error('Error:', error); display: none
      this.showError(); display: none
    }
  }

  async handleAddToCart() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding to cart');
  }

  async handlePreorder() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1,
          properties: {
            '_preorder': true,
            'Estimated Shipping': 'Pre-order - 2-3 semanas',
            'Pre-order': 'Artículo de pre-venta'
          }
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding pre-order');
  }

  setLoading(isLoading) {
    this.button.enabled = isLoading; 
    this.button.classList.toggle('loading', isLoading);display: none
    this.button.textContent = isLoading ? 'Procesando...' : this.originalText; display: none
  }

  showSuccess() {
    const message = this.action === 'preorder' ? 'Pre-orden agregada' : 'Agregado al carrito';
    this.button.textContent = message;
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }

  showError() {
    this.button.textContent = 'Error'; display: none
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }
}

class CartManager {
  static async updateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));
    } catch (error) {
      console.error('Error updating cart:', error); display: none
    }
  }
}

// Agregar al JavaScript existente
document.addEventListener('DOMContentLoaded', function() {
  const priceForm = document.querySelector('.filter-form');
  const priceInputs = document.querySelectorAll('.price-range-inputs input');
  
  priceInputs.forEach(input => {
    input.addEventListener('input', function() {
      if (this.value < 0) this.value = 0;
    });
  });

  document.querySelector('.apply-price-filter')?.addEventListener('click', function(e) {
    e.preventDefault();
    priceForm.submit();
  });
});  

// Inicializar
document.addEventListener('DOMContentLoaded', () => {
  new CollectionManager();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-grid-magic"] && !window.DesignMode) return;
  try {
    
class CollectionManager {
  constructor() {
    this.filterManager = new FilterManager();
    this.cartManager = new CartManager();
    this.initializeButtons();
  }

  initializeButtons() {
    document.querySelectorAll('.product-button').forEach(button => {
      new ProductButton(button);
    });
  }
}

class FilterManager {
  constructor() {
    this.form = document.querySelector('.filter-form');
    this.filterGroups = document.querySelectorAll('.filter-group');
    this.filterInputs = document.querySelectorAll('.filter-option input');
    this.sortSelect = document.querySelector('.sort-select');
    this.perPageSelect = document.querySelector('.per-page-select');
    
    this.init();
  }

  init() {
    this.setupFilterGroups();
    this.setupFilterInputs();
    this.setupSort();
    this.setupPerPage();
    this.initMobileSidebar();
  }

  initMobileSidebar() {
    // Crear botón de toggle para móvil
    const toggleButton = document.createElement('button');
    toggleButton.className = 'filter-toggle-button';
    toggleButton.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M3 5h12M3 9h12M3 13h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      Filtros
    `;
    document.body.appendChild(toggleButton);

    // Crear overlay
    const overlay = document.createElement('div');
    overlay.className = 'sidebar-overlay';
    document.body.appendChild(overlay);

    // Crear header del sidebar
    const sidebarHeader = document.createElement('div');
    sidebarHeader.className = 'sidebar-header';
    sidebarHeader.innerHTML = `
      <h3 class="sidebar-title">Filtros</h3>
      <button class="sidebar-close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    `;
    
    // Insertar header al inicio del sidebar
    const sidebar = document.querySelector('.collection-sidebar');
    sidebar.insertBefore(sidebarHeader, sidebar.firstChild);

    // Event listeners
    toggleButton.addEventListener('click', () => this.toggleSidebar(true));
    overlay.addEventListener('click', () => this.toggleSidebar(false));
    sidebarHeader.querySelector('.sidebar-close').addEventListener('click', () => this.toggleSidebar(false));

    // Cerrar al cambiar filtros en mobile
    if (window.innerWidth <= 991) {
      this.filterInputs.forEach(input => {
        input.addEventListener('change', () => {
          // Pequeño delay para que el usuario vea que se seleccionó el filtro
          setTimeout(() => this.toggleSidebar(false), 300);
        });
      });
    }
  }

  toggleSidebar(show) {
    const sidebar = document.querySelector('.collection-sidebar');
    const overlay = document.querySelector('.sidebar-overlay');
    
    if (show) {
      sidebar.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('sidebar-open');
    } else {
      sidebar.classList.remove('active');
      overlay.classList.remove('active');
      document.body.classList.remove('sidebar-open');
    }
  }

  setupFilterGroups() {
    this.filterGroups.forEach(group => {
      const header = group.querySelector('.filter-group-header');
      const content = group.querySelector('.filter-group-content');
      const toggle = header.querySelector('.filter-toggle');

      // Establecer estado inicial
      content.classList.add('active');
      toggle.textContent = '▼';

      header.addEventListener('click', () => {
        const isExpanded = content.classList.contains('active');
        
        if (isExpanded) {
          content.classList.remove('active');
          toggle.textContent = '▼';
        } else {
          content.classList.add('active');
          toggle.textContent = '▲';
        }
      });
    });
  }

  setupFilterInputs() {
    this.filterInputs.forEach(input => {
      input.addEventListener('change', () => this.handleFilterChange());
    });
  }

  setupSort() {
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location = url.toString();
      });
    }
  }

  setupPerPage() {
    if (this.perPageSelect) {
      this.perPageSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('view', e.target.value);
        window.location = url.toString();
      });
    }
  }

  handleFilterChange() {
    const formData = new FormData(this.form);
    const url = new URL(window.location.href);
    
    // Limpiar filtros existentes
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.')) {
        url.searchParams.delete(key);
      }
    });

    // Añadir filtros activos
    for (let [key, value] of formData.entries()) {
      url.searchParams.append(key, value);
    }

    // Mantener sort y page_size
    const currentSort = url.searchParams.get('sort_by');
    const currentView = url.searchParams.get('view');

    if (currentSort) url.searchParams.set('sort_by', currentSort);
    if (currentView) url.searchParams.set('view', currentView);

    window.location = url.toString();
  }
}

class ProductButton {
  constructor(button) {
    this.button = button;
    this.productId = button.dataset.productId;
    this.productHandle = button.dataset.productHandle;
    this.action = button.dataset.action;
    this.originalText = button.textContent;
    
    this.init();
  }

  init() {
    this.button.addEventListener('click', () => this.handleClick());
  }

  async handleClick() {
    if (this.button.disabled) return;

    try {
      this.setLoading(true);
      
      if (this.action === 'preorder') {
        await this.handlePreorder();
      } else {
        await this.handleAddToCart();
      }
      
      this.showSuccess();
      CartManager.updateCart();
      
    } catch (error) {
      console.error('Error:', error); display: none
      this.showError(); display: none
    }
  }

  async handleAddToCart() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding to cart');
  }

  async handlePreorder() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1,
          properties: {
            '_preorder': true,
            'Estimated Shipping': 'Pre-order - 2-3 semanas',
            'Pre-order': 'Artículo de pre-venta'
          }
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding pre-order');
  }

  setLoading(isLoading) {
    this.button.enabled = isLoading; 
    this.button.classList.toggle('loading', isLoading);display: none
    this.button.textContent = isLoading ? 'Procesando...' : this.originalText; display: none
  }

  showSuccess() {
    const message = this.action === 'preorder' ? 'Pre-orden agregada' : 'Agregado al carrito';
    this.button.textContent = message;
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }

  showError() {
    this.button.textContent = 'Error'; display: none
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }
}

class CartManager {
  static async updateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));
    } catch (error) {
      console.error('Error updating cart:', error); display: none
    }
  }
}

// Agregar al JavaScript existente
document.addEventListener('DOMContentLoaded', function() {
  const priceForm = document.querySelector('.filter-form');
  const priceInputs = document.querySelectorAll('.price-range-inputs input');
  
  priceInputs.forEach(input => {
    input.addEventListener('input', function() {
      if (this.value < 0) this.value = 0;
    });
  });

  document.querySelector('.apply-price-filter')?.addEventListener('click', function(e) {
    e.preventDefault();
    priceForm.submit();
  });
});  

// Inicializar
document.addEventListener('DOMContentLoaded', () => {
  new CollectionManager();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-grid"] && !window.DesignMode) return;
  try {
    
class CollectionManager {
  constructor() {
    this.filterManager = new FilterManager();
    this.cartManager = new CartManager();
    this.initializeButtons();
  }

  initializeButtons() {
    document.querySelectorAll('.product-button').forEach(button => {
      new ProductButton(button);
    });
  }
}

class FilterManager {
  constructor() {
    this.form = document.querySelector('.filter-form');
    this.filterGroups = document.querySelectorAll('.filter-group');
    this.filterInputs = document.querySelectorAll('.filter-option input');
    this.sortSelect = document.querySelector('.sort-select');
    this.perPageSelect = document.querySelector('.per-page-select');
    
    this.init();
  }

  init() {
    this.setupFilterGroups();
    this.setupFilterInputs();
    this.setupSort();
    this.setupPerPage();
    this.initMobileSidebar();
  }

  initMobileSidebar() {
    // Crear botón de toggle para móvil
    const toggleButton = document.createElement('button');
    toggleButton.className = 'filter-toggle-button';
    toggleButton.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M3 5h12M3 9h12M3 13h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      Filtros
    `;
    document.body.appendChild(toggleButton);

    // Crear overlay
    const overlay = document.createElement('div');
    overlay.className = 'sidebar-overlay';
    document.body.appendChild(overlay);

    // Crear header del sidebar
    const sidebarHeader = document.createElement('div');
    sidebarHeader.className = 'sidebar-header';
    sidebarHeader.innerHTML = `
      <h3 class="sidebar-title">Filtros</h3>
      <button class="sidebar-close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    `;
    
    // Insertar header al inicio del sidebar
    const sidebar = document.querySelector('.collection-sidebar');
    sidebar.insertBefore(sidebarHeader, sidebar.firstChild);

    // Event listeners
    toggleButton.addEventListener('click', () => this.toggleSidebar(true));
    overlay.addEventListener('click', () => this.toggleSidebar(false));
    sidebarHeader.querySelector('.sidebar-close').addEventListener('click', () => this.toggleSidebar(false));

    // Cerrar al cambiar filtros en mobile
    if (window.innerWidth <= 991) {
      this.filterInputs.forEach(input => {
        input.addEventListener('change', () => {
          // Pequeño delay para que el usuario vea que se seleccionó el filtro
          setTimeout(() => this.toggleSidebar(false), 300);
        });
      });
    }
  }

  toggleSidebar(show) {
    const sidebar = document.querySelector('.collection-sidebar');
    const overlay = document.querySelector('.sidebar-overlay');
    
    if (show) {
      sidebar.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('sidebar-open');
    } else {
      sidebar.classList.remove('active');
      overlay.classList.remove('active');
      document.body.classList.remove('sidebar-open');
    }
  }

  setupFilterGroups() {
    this.filterGroups.forEach(group => {
      const header = group.querySelector('.filter-group-header');
      const content = group.querySelector('.filter-group-content');
      const toggle = header.querySelector('.filter-toggle');

      // Establecer estado inicial
      content.classList.add('active');
      toggle.textContent = '▲';

      header.addEventListener('click', () => {
        const isExpanded = content.classList.contains('active');
        
        if (isExpanded) {
          content.classList.remove('active');
          toggle.textContent = '▼';
        } else {
          content.classList.add('active');
          toggle.textContent = '▲';
        }
      });
    });
  }

  setupFilterInputs() {
    this.filterInputs.forEach(input => {
      input.addEventListener('change', () => this.handleFilterChange());
    });
  }

  setupSort() {
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location = url.toString();
      });
    }
  }

  setupPerPage() {
    if (this.perPageSelect) {
      this.perPageSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('view', e.target.value);
        window.location = url.toString();
      });
    }
  }

  handleFilterChange() {
    const formData = new FormData(this.form);
    const url = new URL(window.location.href);
    
    // Limpiar filtros existentes
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.')) {
        url.searchParams.delete(key);
      }
    });

    // Añadir filtros activos
    for (let [key, value] of formData.entries()) {
      url.searchParams.append(key, value);
    }

    // Mantener sort y page_size
    const currentSort = url.searchParams.get('sort_by');
    const currentView = url.searchParams.get('view');

    if (currentSort) url.searchParams.set('sort_by', currentSort);
    if (currentView) url.searchParams.set('view', currentView);

    window.location = url.toString();
  }
}

class ProductButton {
  constructor(button) {
    this.button = button;
    this.productId = button.dataset.productId;
    this.productHandle = button.dataset.productHandle;
    this.action = button.dataset.action;
    this.originalText = button.textContent;
    
    this.init();
  }

  init() {
    this.button.addEventListener('click', () => this.handleClick());
  }

  async handleClick() {
    if (this.button.disabled) return;

    try {
      this.setLoading(true);
      
      if (this.action === 'preorder') {
        await this.handlePreorder();
      } else {
        await this.handleAddToCart();
      }
      
      this.showSuccess();
      CartManager.updateCart();
      
    } catch (error) {
      console.error('Error:', error); display: none
      this.showError(); display: none
    }
  }

  async handleAddToCart() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding to cart');
  }

  async handlePreorder() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1,
          properties: {
            '_preorder': true,
            'Estimated Shipping': 'Pre-order - 2-3 semanas',
            'Pre-order': 'Artículo de pre-venta'
          }
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding pre-order');
  }

  setLoading(isLoading) {
    this.button.enabled = isLoading; 
    this.button.classList.toggle('loading', isLoading);display: none
    this.button.textContent = isLoading ? 'Procesando...' : this.originalText; display: none
  }

  showSuccess() {
    const message = this.action === 'preorder' ? 'Pre-orden agregada' : 'Agregado al carrito';
    this.button.textContent = message;
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }

  showError() {
    this.button.textContent = 'Error'; display: none
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }
}

class CartManager {
  static async updateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));
    } catch (error) {
      console.error('Error updating cart:', error); display: none
    }
  }
}

// Agregar al JavaScript existente
document.addEventListener('DOMContentLoaded', function() {
  const priceForm = document.querySelector('.filter-form');
  const priceInputs = document.querySelectorAll('.price-range-inputs input');
  
  priceInputs.forEach(input => {
    input.addEventListener('input', function() {
      if (this.value < 0) this.value = 0;
    });
  });

  document.querySelector('.apply-price-filter')?.addEventListener('click', function(e) {
    e.preventDefault();
    priceForm.submit();
  });
});  

// Inicializar
document.addEventListener('DOMContentLoaded', () => {
  new CollectionManager();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !window.DesignMode) return;
  try {
    
// Animate elements when they enter viewport
if (document.querySelector('.blog-card')) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, {
    threshold: 0.1
  });

  document.querySelectorAll('.blog-card').forEach((card) => {
    observer.observe(card);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Featured-News-Banner"] && !window.DesignMode) return;
  try {
    
class FeaturedNewsBanner {
  constructor(section) {
    this.container = section;
    this.slides = this.container.querySelectorAll('.featured-news__slide');
    this.dots = this.container.querySelectorAll('.featured-news__dot');
    this.currentIndex = 0;
    this.autoplayInterval = null;
    this.transitionInProgress = false;

    this.init();
  }

  init() {
    if (this.slides.length <= 1) return;

    this.bindEvents();
    this.startAutoplay();
  }

  bindEvents() {
    this.dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.index);
        this.goToSlide(index);
      });
    });

    // Pause autoplay on hover/touch
    this.container.addEventListener('mouseenter', () => this.stopAutoplay());
    this.container.addEventListener('mouseleave', () => this.startAutoplay());
    this.container.addEventListener('touchstart', () => this.stopAutoplay());
    this.container.addEventListener('touchend', () => this.startAutoplay());

    // Handle visibility change
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    });
  }

  goToSlide(index) {
    if (this.transitionInProgress || index === this.currentIndex) return;

    this.transitionInProgress = true;
    
    // Remove active classes
    this.slides[this.currentIndex].classList.remove('is-active');
    this.dots[this.currentIndex].classList.remove('is-active');
    this.dots[this.currentIndex].setAttribute('aria-selected', 'false');

    // Add active classes
    this.slides[index].classList.add('is-active');
    this.dots[index].classList.add('is-active');
    this.dots[index].setAttribute('aria-selected', 'true');

    // Update current index
    this.currentIndex = index;

    // Reset transition lock
    setTimeout(() => {
      this.transitionInProgress = false;
    }, 600);
  }

  startAutoplay() {
    if (this.slides.length <= 1) return;

    this.autoplayInterval = setInterval(() => {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }, 5000);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }
}

// Initialize the section
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.featured-news');
  if (section) {
    new FeaturedNewsBanner(section);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // Código existente de la carta holográfica
  const root = document.documentElement;
  const holoCard = document.querySelector('.hero-holo-card .card');
  const featuredCardImage = document.querySelector('.featured-card-image');
  const slides = document.querySelectorAll('.hero-banner__slide');

  // Nuevas variables para el carousel
  const banner = document.querySelector('[data-banner]');
  const dots = document.querySelectorAll('.hero-banner__dot');
  const autoplaySpeed = parseInt(banner?.dataset.autoplaySpeed) * 1000 || 5000;
  let currentSlide = 0;
  let autoplayInterval;
  
  if (!holoCard || !featuredCardImage) return;

  let isHovering = false;
  let animationFrame;
  
  // Configuración
  const config = {
    // Animación automática
    autoAnimation: {
      start: Date.now(),
      duration: 6000, // 6 segundos por ciclo
      rotationIntensity: {
        auto: { x: 1, y: 2 },    // Intensidad de rotación automática
        hover: { x: 5, y: 5 }     // Intensidad de rotación con hover
      }
    },
    // Efectos holográficos
    holo: {
      baseOpacity: 0.5,          // Opacidad base del efecto
      opacityIntensity: 0.3,     // Intensidad máxima adicional
      blurRadius: '3rem',        // Radio del efecto blur
      gradientSize: '150px'      // Tamaño del gradiente
    },
    // Transiciones
    transition: {
      duration: 300,            // Duración de la transición en ms
      timing: 'ease-out'        // Timing function
    }
  };

  // Funciones del carousel
  function showSlide(index) {
    slides.forEach(slide => slide.classList.remove('is-active'));
    dots.forEach(dot => dot.classList.remove('is-active'));
    
    slides[index].classList.add('is-active');
    dots[index].classList.add('is-active');
    
    updateFeaturedCard();
  }

  function nextSlide() {
    currentSlide = (currentSlide + 1) % slides.length;
    showSlide(currentSlide);
  }

  function prevSlide() {
    currentSlide = (currentSlide - 1 + slides.length) % slides.length;
    showSlide(currentSlide);
  }

  function startAutoplay() {
    if (autoplayInterval) clearInterval(autoplayInterval);
    autoplayInterval = setInterval(nextSlide, autoplaySpeed);
  }

  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }

  // Event listeners para navegación
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentSlide = index;
      showSlide(currentSlide);
      startAutoplay();
    });
  });

  banner.addEventListener('mouseenter', stopAutoplay);
  banner.addEventListener('mouseleave', startAutoplay);

  // Modificar el manejo de visibilidad de página
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      cancelAnimationFrame(animationFrame);
      stopAutoplay();
    } else if (!isHovering) {
      autoAnimate();
      startAutoplay();
    }
  });

  // Función para actualizar la carta según el slide activo
 function updateFeaturedCard() {
  const activeSlide = document.querySelector('.hero-banner__slide.is-active');
  if (!activeSlide) return;

  const cardImageUrl = activeSlide.dataset.featuredCard;
  if (!cardImageUrl) return;

  const cardContainer = document.querySelector('.hero-holo-card');
  const cardWrapper = document.querySelector('.card-wrapper');
  const frontImage = document.querySelector('.featured-card-image');
  const backImage = document.querySelector('.featured-card-image-back');

  // Añadir clase para ocultar efectos durante la transición
  cardContainer.classList.add('is-flipping');

  // Determinar si la carta está en su posición frontal o posterior
  const isFlipped = cardWrapper.style.transform.includes('180deg');
  
  // Establecer la nueva imagen en el lado opuesto
  if (isFlipped) {
    frontImage.src = cardImageUrl;
  } else {
    backImage.src = cardImageUrl;
  }

  // Realizar el flip
  cardWrapper.style.transform = isFlipped ? 'rotateY(0deg)' : 'rotateY(180deg)';

  // Restaurar efectos después de la transición
  cardWrapper.addEventListener('transitionend', function handler() {
    // Pequeño retraso antes de remover la clase is-flipping
    setTimeout(() => {
      cardContainer.classList.remove('is-flipping');
    }, 50);
    
    // Actualizar la imagen del otro lado para mantener sincronización
    if (isFlipped) {
      backImage.src = cardImageUrl;
    } else {
      frontImage.src = cardImageUrl;
    }
    
    cardWrapper.removeEventListener('transitionend', handler);
  }, { once: true });
}

  // Observer para detectar cambios en los slides
  const slideObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.classList.contains('is-active')) {
        updateFeaturedCard();
      }
    });
  });

  // Observar cambios en cada slide
  slides.forEach(slide => {
    slideObserver.observe(slide, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  // Establecer variables CSS iniciales
  root.style.setProperty('--active-blur', config.holo.baseOpacity.toString());
  root.style.setProperty('--gradient-size', config.holo.gradientSize);
  
  // Función para la animación automática
  function autoAnimate() {
    if (isHovering) return;
    
    const now = Date.now();
    const elapsed = now - config.autoAnimation.start;
    const progress = (elapsed % config.autoAnimation.duration) / config.autoAnimation.duration;
    
    // Movimiento circular suave
    const angle = progress * Math.PI * 2;
    const rotateY = Math.sin(angle) * config.autoAnimation.rotationIntensity.auto.y;
    const rotateX = Math.cos(angle) * config.autoAnimation.rotationIntensity.auto.x;
    
    // Aplicar transformación
    holoCard.style.transform = `
      perspective(2000px)
      rotateY(${rotateY}deg) 
      rotateX(${rotateX}deg)
    `;
    
    // Efecto de brillo automático
    const x = (Math.sin(angle) * 0.5 + 0.5) * 100;
    const y = (Math.cos(angle) * 0.5 + 0.5) * 100;
    updateHoloEffect(x, y);
    
    animationFrame = requestAnimationFrame(autoAnimate);
  }

  // Función para actualizar el efecto holográfico
  function updateHoloEffect(x, y) {
    const intensity = (Math.sin(Date.now() / 1000) * 0.5 + 0.5) * config.holo.opacityIntensity;
    const opacity = config.holo.baseOpacity + intensity;
    
    root.style.setProperty('--mouse-x', `${x}%`);
    root.style.setProperty('--mouse-y', `${y}%`);
    root.style.setProperty('--active-blur', opacity.toString());
    root.style.setProperty('--active-scale', '1');
  }

  // Eventos del mouse
  holoCard.addEventListener('mouseenter', () => {
    isHovering = true;
    cancelAnimationFrame(animationFrame);
    holoCard.style.transition = `transform ${config.transition.duration}ms ${config.transition.timing}`;
  });

  holoCard.addEventListener('mousemove', (e) => {
    if (!isHovering) return;

    const rect = holoCard.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const percentX = (mouseX - centerX) / centerX;
    const percentY = (mouseY - centerY) / centerY;

    const rotateY = percentX * config.autoAnimation.rotationIntensity.hover.y;
    const rotateX = -percentY * config.autoAnimation.rotationIntensity.hover.x;

    holoCard.style.transform = `
      perspective(2000px)
      rotateY(${rotateY}deg)
      rotateX(${rotateX}deg)
      scale3d(1.02, 1.02, 1.02)
    `;

    updateHoloEffect(
      (mouseX / rect.width) * 100,
      (mouseY / rect.height) * 100
    );
  });

  holoCard.addEventListener('mouseleave', () => {
    isHovering = false;
    holoCard.style.transition = `transform ${config.transition.duration * 2}ms ${config.transition.timing}`;
    holoCard.style.transform = 'rotateY(0) rotateX(0)';
    
    config.autoAnimation.start = Date.now();
    autoAnimate();
  });

  // Optimización del rendimiento
  window.addEventListener('resize', _.debounce(() => {
    if (holoCard) {
      holoCard.style.transform = 'rotateY(0) rotateX(0)';
    }
  }, 250));

  // Inicialización
  updateFeaturedCard(); // Establecer carta inicial
  autoAnimate();       // Iniciar animación automática
  startAutoplay();

  // Manejo de visibilidad de página
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      cancelAnimationFrame(animationFrame);
    } else if (!isHovering) {
      autoAnimate();
    }
  });

  // Limpieza
  window.addEventListener('unload', () => {
    slideObserver.disconnect();
    cancelAnimationFrame(animationFrame);
    stopAutoplay();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductPage {
  constructor() {
    if (!this.checkElements()) return;
    this.initializeElements();
    this.initializeState();
    if (this.state.isPreorder && !this.validatePreorderSetup()) {
      console.error('Configuración de preventa inválida');
      return;
    }
    this.bindEvents();
  }

  checkElements() {
    const required = [
      '.quantity-input',
      '.product-button',
      '.tab-button',
      '.tab-panel',
      '#ProductMainImage'
    ];

    return required.every(selector => document.querySelector(selector));
  }

  initializeElements() {
    // Elementos de cantidad
    this.quantityInput = document.querySelector('.quantity-input');
    this.quantityBtns = document.querySelectorAll('.quantity-btn');
    
    // Elementos de tabs
    this.tabButtons = document.querySelectorAll('.tab-button');
    
    // Elementos de galería
    this.mainImage = document.querySelector('#ProductMainImage');
    this.thumbnails = document.querySelectorAll('.thumbnail-item');
    
    // Botones de preventa/carrito
    this.cartButtons = document.querySelectorAll('.product-button');
    
    // Elementos de precios
    this.priceElements = {
      total: document.querySelector('.price-total'),
      reserve: document.querySelector('.price-reserve'),
      remaining: document.querySelector('.remaining-balance .price-value')
    };
  }

  initializeState() {
    const preorderButton = document.querySelector('.product-button.initial-payment');
    const fullPaymentButton = document.querySelector('.product-button.full-payment');
    
    this.state = {
      quantity: 1,
      selectedVariantId: this.getSelectedVariantId(),
      isPreorder: this.checkIfPreorder(),
      prices: null,
      preorderVariantId: preorderButton?.dataset.preorderVariantId || null
    };

    // Verificar datos necesarios para preventa
    if (this.state.isPreorder) {
      const initialPrice = preorderButton ? parseFloat(preorderButton.dataset.initialPrice) : 0;
      const totalPrice = fullPaymentButton ? parseFloat(fullPaymentButton.dataset.totalPrice) : 0;
      
      if (!initialPrice || !totalPrice || !this.state.preorderVariantId) {
        console.error('Faltan datos necesarios para la preventa:', {
          initialPrice,
          totalPrice,
          preorderVariantId: this.state.preorderVariantId
        });
        this.state.isPreorder = false;
      } else {
        this.state.prices = { initial: initialPrice, total: totalPrice };
      }
    }
  }

  validatePreorderSetup() {
    if (!this.state.isPreorder) return true;

    const validations = [
      {
        condition: !!this.state.preorderVariantId,
        message: 'No se encontró la variante de apartado'
      },
      {
        condition: !!this.state.prices?.initial,
        message: 'Precio de apartado no configurado'
      },
      {
        condition: !!this.state.prices?.total,
        message: 'Precio total no configurado'
      }
    ];

    const failures = validations
      .filter(v => !v.condition)
      .map(v => v.message);

    if (failures.length > 0) {
      console.error('Errores en la configuración de preventa:', failures);
      return false;
    }

    return true;
  }

  getSelectedVariantId() {
    const variantSelect = document.querySelector('#ProductSelect');
    return variantSelect ? variantSelect.value : this.cartButtons[0].dataset.productId;
  }

  checkIfPreorder() {
    return document.querySelector('.preorder-badge') !== null && 
           this.verifyPreorderVariant();
  }

  verifyPreorderVariant() {
    const preorderButton = document.querySelector('.product-button.initial-payment');
    if (!preorderButton) return false;

    const preorderVariantId = preorderButton.dataset.preorderVariantId;
    if (!preorderVariantId) {
      console.error('No se encontró la variante de apartado');
      return false;
    }

    return true;
  }

  bindEvents() {
    // Eventos de cantidad
    this.quantityBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleQuantityChange(btn.dataset.action);
      });
    });

    this.quantityInput.addEventListener('change', () => this.handleQuantityInput());
    
    // Eventos de tabs
    this.tabButtons.forEach(button => {
      button.addEventListener('click', () => this.handleTabChange(button));
    });
    
    // Eventos de galería
    this.thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => this.handleThumbnailClick(thumb));
    });
    
    // Eventos de carrito
    this.cartButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleAddToCart(button);
      });
    });

    // Eventos de variantes
    const variantSelect = document.querySelector('#ProductSelect');
    if (variantSelect) {
      variantSelect.addEventListener('change', () => this.handleVariantChange());
    }
  }

  handleQuantityChange(action) {
    let newQuantity = parseInt(this.quantityInput.value);
    
    if (action === 'decrease' && newQuantity > 1) {
      newQuantity--;
    } else if (action === 'increase') {
      newQuantity++;
    }

    this.updateQuantity(newQuantity);
  }

  handleQuantityInput() {
    let value = parseInt(this.quantityInput.value);
    if (isNaN(value) || value < 1) value = 1;
    this.updateQuantity(value);
  }

  updateQuantity(quantity) {
    this.state.quantity = quantity;
    this.quantityInput.value = quantity;
    this.updatePrices();
    this.updateButtonText();
  }

  

  handleThumbnailClick(thumbnail) {
    const newSrc = thumbnail.querySelector('img').dataset.mainSrc;
    
    // Transición suave
    this.mainImage.style.opacity = '0';
    setTimeout(() => {
      this.mainImage.src = newSrc;
      this.mainImage.style.opacity = '1';
    }, 300);
    
    this.thumbnails.forEach(thumb => {
      thumb.classList.toggle('active', thumb === thumbnail);
    });
  }

  handleVariantChange() {
    this.state.selectedVariantId = this.getSelectedVariantId();
    this.updatePrices();
    this.updateButtonStates();
  }

  updatePrices() {
    if (!this.state.isPreorder) return;

    const quantity = this.state.quantity;
    const { total, initial } = this.state.prices;

    if (this.priceElements.total) {
      this.priceElements.total.textContent = this.formatMoney(total * quantity);
    }
    if (this.priceElements.reserve) {
      this.priceElements.reserve.textContent = this.formatMoney(initial * quantity);
    }
    if (this.priceElements.remaining) {
      this.priceElements.remaining.textContent = 
        this.formatMoney((total - initial) * quantity);
    }
  }

  updateButtonText() {
    this.cartButtons.forEach(button => {
      const isPreorderBtn = button.classList.contains('preorder');
      const paymentType = button.dataset.paymentType;
      const quantity = this.state.quantity;
      
      let buttonText = '';
      if (isPreorderBtn) {
        if (paymentType === 'full') {
          const totalPrice = (this.state.prices.total * quantity).toFixed(2);
          buttonText = `Pagar Precio Total ($${totalPrice})`;
        } else {
          const initialPrice = (this.state.prices.initial * quantity).toFixed(2);
          buttonText = `Realizar Apartado ($${initialPrice})`;
        }
      } else {
        buttonText = quantity > 1 ? `Agregar ${quantity} al carrito` : 'Agregar al carrito';
      }
      
      button.textContent = buttonText;
    });
  }

  updateButtonStates() {
    const variant = this.getSelectedVariant();
    const isAvailable = variant && variant.available;

    this.cartButtons.forEach(button => {
      button.disabled = !isAvailable;
      if (!isAvailable) {
        button.textContent = 'Agotado';
      } else {
        this.updateButtonText();
      }
    });
  }

  getSelectedVariant() {
    const select = document.querySelector('#ProductSelect');
    if (!select) return null;
    
    const option = select.options[select.selectedIndex];
    return {
      id: option.value,
      available: !option.disabled
    };
  }

  
async handleAddToCart(button) {
  if (button.disabled || button.classList.contains('loading')) return;
  
  const isPreorder = button.classList.contains('preorder');
  const paymentType = button.dataset.paymentType;
  const quantity = this.state.quantity;

  try {
    this.setButtonLoading(button, true);
    
    // Obtener el producto actual y sus variantes
    if (!window.product) {
      throw new Error('No se encontró información del producto');
    }

    let selectedVariant;
    let cartProperties = {};

    if (isPreorder) {
      // Lógica para productos de preventa
      if (!window.product.variants || window.product.variants.length < 2) {
        throw new Error('El producto de preventa no tiene suficientes variantes');
      }

      if (paymentType === 'full') {
        // Pago total: usar primera variante
        selectedVariant = window.product.variants[0];
        cartProperties = {
          '_tipo_pago': 'Pago total preventa',
          '_monto_total': (selectedVariant.price / 100).toFixed(2),
          '_cantidad': quantity,
          '_es_pago_completo': true
        };
      } else {
        // Apartado: usar segunda variante
        selectedVariant = window.product.variants[1];
        const precioTotal = window.product.variants[0].price / 100;
        const precioApartado = selectedVariant.price / 100;
        
        cartProperties = {
          '_tipo_pago': 'Apartado preventa',
          '_monto_apartado': precioApartado.toFixed(2),
          '_precio_total': precioTotal.toFixed(2),
          '_saldo_pendiente': (precioTotal - precioApartado).toFixed(2),
          '_cantidad': quantity,
          '_es_apartado': true
        };
      }
    } else {
      // Lógica para productos normales
      const variantId = button.dataset.productId;
      selectedVariant = {
        id: variantId
      };
    }

    // Verificar que la variante sea válida
    if (!selectedVariant || !selectedVariant.id) {
      throw new Error('No se pudo obtener una variante válida');
    }

    // Preparar datos para el carrito
    const cartData = {
      items: [{
        id: selectedVariant.id,
        quantity: quantity,
        properties: cartProperties
      }]
    };

    console.log('Datos a enviar al carrito:', cartData);

    // Construir URL completa para el carrito
    const cartUrl = window.Shopify && window.Shopify.routes ? 
      window.Shopify.routes.root + 'cart/add.js' : 
      '/cart/add.js';

    // Realizar solicitud a Shopify
    const response = await fetch(cartUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify(cartData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error response:', errorData);      
      throw new Error(errorData.description || 'Error al agregar al carrito');
    }

    const result = await response.json();
    console.log('Respuesta del carrito:', result);

    // Mensaje de éxito según tipo de operación
    const successMessage = isPreorder ? 
      (paymentType === 'full' ? 
        `Pago total de ${quantity} producto(s) agregado al carrito` :
        `Apartado de ${quantity} producto(s) agregado al carrito`) :
      `${quantity} producto(s) agregado al carrito`;

    this.showMessage(successMessage, 'success');
    
    // Actualizar el mini carrito
    document.dispatchEvent(new CustomEvent('cart:updated', { 
      detail: { 
        cart: result,
        addedItems: [{
          variantId: selectedVariant.id,
          quantity,
          properties: cartProperties
        }]
      } 
    }));

  } catch (error) {
    console.error('Error al agregar al carrito:', error);
    this.showMessage(error.message || 'Error al agregar al carrito', 'error');
  } finally {
    this.setButtonLoading(button, false);
  }
}

  setButtonLoading(button, isLoading) {
    button.disabled = isLoading;
    button.classList.toggle('loading', isLoading);
    
    if (isLoading) {
      button.dataset.originalText = button.textContent;
      button.textContent = 'Agregando...';
    } else {
      button.textContent = button.dataset.originalText;
      delete button.dataset.originalText;
    }
  }

  showMessage(message, type = 'success') {
    const messageElement = document.createElement('div');
    messageElement.className = `cart-message cart-message-${type}`;
    messageElement.innerHTML = `
      <div class="message-content">
        <span class="message-icon">${type === 'success' ? '✓' : '✕'}</span>
        <span class="message-text">${message}</span>
      </div>
    `;
    
    document.body.appendChild(messageElement);
    
    // Agregar clase para la animación de entrada
    requestAnimationFrame(() => {
      messageElement.classList.add('show');
    });
    
    setTimeout(() => {
      messageElement.classList.remove('show');
      setTimeout(() => messageElement.remove(), 300);
    }, 3000);
  }

  formatMoney(amount) {
    return `$${parseFloat(amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
  }
}
    // Tabs
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabPanels = document.querySelectorAll('.tab-panel');

  tabButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = button.getAttribute('data-tab-target');
      
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabPanels.forEach(panel => panel.classList.remove('active'));
      
      button.classList.add('active');
      document.getElementById(targetId)?.classList.add('active');
    });
  });

// Estilos para los mensajes
const style = document.createElement('style');
style.textContent = `
  .cart-message {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
    transform: translateX(120%);
    transition: transform 0.3s ease-in-out;
  }

  .cart-message.show {
    transform: translateX(0);
  }

  .message-content {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 20px;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    animation: slideIn 0.3s ease-out;
  }

  .cart-message-success .message-content {
    background-color: #4caf50;
    color: white;
  }

  .cart-message-error .message-content {
    background-color: #f44336;
    color: white;
  }

  .message-icon {
    font-size: 18px;
  }

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .product-button.loading {
    opacity: 0.7;
    cursor: wait;
  }

  @media (max-width: 768px) {
    .cart-message {
      top: auto;
      bottom: 20px;
      right: 50%;
      transform: translate(50%, 120%);
    }

    .cart-message.show {
      transform: translate(50%, 0);
    }
  }
`;

document.head.appendChild(style);

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  try {
    const productPage = new ProductPage();
    window.productPage = productPage; // Para acceso en la consola si es necesario
  } catch (error) {
    console.error('Error al inicializar ProductPage:', error);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosotros"] && !window.DesignMode) return;
  try {
    
// Animaciones al hacer scroll
document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
      }
    });
  }, {
    threshold: 0.1
  });

  document.querySelectorAll('.value-card, .team-card, .timeline__event').forEach(el => {
    observer.observe(el);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Product-filters-component"]) return;
  try {
    
class ProductFilters {
  constructor() {
    this.filters = new Set();
    this.activeFilters = {};
    this.init();
  }

  init() {
    this.bindEvents();
    this.initActiveFiltersFromUrl();
  }

  initActiveFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    params.forEach((value, key) => {
      this.addFilter(key, value);
      
      // Check corresponding checkbox
      const input = document.querySelector(`input[name="${key}"][value="${value}"]`);
      if (input) {
        input.checked = true;
        input.previousElementSibling.classList.add('checked');
      }
    });
    this.updateActiveFilters();
  }

  bindEvents() {
    // Filter Group Toggle
    document.querySelectorAll('.filter-group-title').forEach(title => {
      title.addEventListener('click', () => {
        const content = title.nextElementSibling;
        content.classList.toggle('active');
      });
    });

    // Filter Checkboxes
    document.querySelectorAll('.filter-option input').forEach(input => {
      input.addEventListener('change', (e) => {
        const checkbox = e.target.previousElementSibling;
        checkbox.classList.toggle('checked');
        
        if (e.target.checked) {
          this.addFilter(e.target.name, e.target.value);
        } else {
          this.removeFilter(e.target.name, e.target.value);
        }
        
        this.updateActiveFilters();
        this.applyFilters();
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.filter-group')) {
        document.querySelectorAll('.filter-group-content').forEach(content => {
          content.classList.remove('active');
        });
      }
    });
  }

  addFilter(type, value) {
    if (!this.activeFilters[type]) {
      this.activeFilters[type] = new Set();
    }
    this.activeFilters[type].add(value);
    this.filters.add(`${type}:${value}`);
  }

  removeFilter(type, value) {
    this.activeFilters[type]?.delete(value);
    if (this.activeFilters[type]?.size === 0) {
      delete this.activeFilters[type];
    }
    this.filters.delete(`${type}:${value}`);
  }

  updateActiveFilters() {
    const container = document.querySelector('.active-filters');
    container.innerHTML = '';

    this.filters.forEach(filter => {
      const [type, value] = filter.split(':');
      const chip = document.createElement('div');
      chip.className = 'active-filter';
      chip.innerHTML = `
        ${this.formatFilterLabel(type, value)}
        <button class="clear-filter" data-filter="${filter}">×</button>
      `;
      container.appendChild(chip);
    });

    this.bindClearButtons();
  }

  formatFilterLabel(type, value) {
    switch(type) {
      case 'price':
        if (value.endsWith('up')) {
          return `$${value.split('-')[0]}+`;
        }
        return `$${value.replace('-', ' - $')}`;
      case 'availability':
        return value === 'in-stock' ? 'In Stock' : 'Out of Stock';
      default:
        return value.replace(/-/g, ' ');
    }
  }

  bindClearButtons() {
    document.querySelectorAll('.clear-filter').forEach(button => {
      button.addEventListener('click', (e) => {
        const filter = e.target.dataset.filter;
        const [type, value] = filter.split(':');
        
        this.removeFilter(type, value);
        
        const input = document.querySelector(`input[name="${type}"][value="${value}"]`);
        if (input) {
          input.checked = false;
          input.previousElementSibling.classList.remove('checked');
        }
        
        this.updateActiveFilters();
        this.applyFilters();
      });
    });
  }

  applyFilters() {
    const params = new URLSearchParams();
    
    Object.entries(this.activeFilters).forEach(([type, values]) => {
      values.forEach(value => {
        params.append(type, value);
      });
    });

    const url = `${window.location.pathname}?${params.toString()}`;
    
    // Disparar evento para actualizar el grid
    const event = new CustomEvent('filtersUpdated', {
      detail: { url }
    });
    document.dispatchEvent(event);
  }
}

// Inicializar los filtros cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new ProductFilters();
});

  } catch(e) { console.error(e); }
})();
})();
